import mun from '../../assets/images/mun.png';
import { Coords } from './Experience';
export type Degree = {
    start: Date;
    end: Date;
    institution: string;
    degree: string;
    field: string;
    addresses: {
        street: string;
        city: string;
        region: string;
        country: string;
        coords: Coords;
    }[];
    highlights: string[]; // Achievements, research, or special projects
    logoImg: any;
};

export const education: Degree[] = [
    {
        start: new Date(2013, 9), // September 2010
        end: new Date(2018, 4),  // May 2015
        institution: "Memorial University of Newfoundland",
        degree: "Bachelor of Engineering",
        field: "Mechanical Engineering",
        addresses: [{
            street: "230 Elizabeth Ave",
            city: "St. John's",
            region: "Newfoundland and Labrador",
            country: "Canada",
            coords: { lat: 47.574389, lon: -52.732675 },
        }],
        highlights: [
            "President of the Engineering Class",
            "Technical stream in Mechatronics",
        ],
        logoImg: mun,
    },
    {
        start: new Date(2017, 8), // September 2015
        end: new Date(2018, 4),  // May 2016
        institution: "Memorial University of Newfoundland",
        degree: "Master's of Engineering",
        field: "Mechanical Engineering",
        addresses: [{
            street: "230 Elizabeth Ave",
            city: "St. John's",
            region: "Newfoundland and Labrador",
            country: "Canada",
            coords: { lat: 47.574389, lon: -52.732675 },
        }],
        highlights: [
            "Started during completion of Bachelor's degree",
            "Thesis based. Using drone methods to determine ice rubble characteristics correlation to ice thickness in the North",
            "Leave of absense during COVID-19 pandemic",
            "Currently unfinished",
        ],
        logoImg: mun,
    },
];

